export type OrderModes = 'row' | 'column';

export type OrderType = 'open' | 'history';

export enum OrderTypeEnum {
  OPEN = 'open',
  HISTORY = 'history',
}